import SalesReport from '../SalesReport/SalesReport';
import * as S from './SalesOverview.style';
import { useSalesQuery } from '../../../pages/salesOverview/model/query/sales.query';
import { ALL_SALES_SUMMARY_MAP, SILOVE_SALES_SUMMARY_MAP, SINOR_SALES_SUMMARY_MAP } from './salesOverview.attribute';
import SummaryCard from '../SalesSummaryCard/SummaryCard';

export default function SalesOverview({ dateState, currentCategory }) {
    const { dateType, startDate, endDate } = dateState;
    const isEnabled = dateType === 'custom' ? !!startDate && !!endDate : true;

    const { data, isLoading } = useSalesQuery(dateType, currentCategory, startDate, endDate, isEnabled);
    if (!isEnabled) return <div>날짜를 마저 선택해 주세요.</div>;
    if (isLoading) return <div>Loading...</div>;
    if (!data) return <div>No data available</div>;

    const summaryMap =
        currentCategory === 'all' ? ALL_SALES_SUMMARY_MAP : currentCategory === 'sinor' ? SINOR_SALES_SUMMARY_MAP : currentCategory === 'silove' ? SILOVE_SALES_SUMMARY_MAP : ALL_SALES_SUMMARY_MAP;
    return (
        <>
            <S.SummarySection>
                <S.SummaryCardContainer>
                    {summaryMap.slice(0, 4).map((summary) => (
                        <SummaryCard key={summary.id} summary={summary} previous={data.previous} current={data.current} dateType={dateType} />
                    ))}
                </S.SummaryCardContainer>

                {dateType !== 'custom' && (
                    <>
                        <S.HR />
                        <S.ReportsContainer>
                            <SalesReport variant="amount" dateType={dateType} current={data.current} previous={data.previous} category={currentCategory} />
                            <SalesReport variant="count" dateType={dateType} current={data.current} previous={data.previous} category={currentCategory} />
                        </S.ReportsContainer>
                    </>
                )}
                <S.HR />
                <S.SummaryCardContainer>
                    {summaryMap.slice(4, summaryMap.length).map((summary) => (
                        <SummaryCard summary={summary} previous={data.previous} current={data.current} key={summary.id} dateType={dateType} />
                    ))}
                </S.SummaryCardContainer>
            </S.SummarySection>
            <S.HR />
        </>
    );
}
